import {z} from 'zod';

export default z.object({
    element: z.enum('h1', 'h2', 'h3', 'h4', 'h5'),
    title: z.string().max(1024),
    custom_fields: z.any().optional()
});
